var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isInternalLink ? 'nuxt-link' : 'a',_vm._b({tag:"component",class:_vm.classNames},'component',_vm.linkComponentOptions,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.link.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }